<p-card>
  <header class="recovery-brand">
    @if ($branding.logoMenu(); as logo) {
      <img class="recovery-brand__logo" [src]="logo" alt="" />
    }
    @if ($branding.displayName(); as brandName) {
      <p class="recovery-brand__name">{{ brandName }}</p>
    }
    <h1 class="recovery-title">¿Has olvidado tu contraseña?</h1>
  </header>
  <p class="recovery-lead">
    Introduce el email asociado a tu cuenta. Recibirás un correo con instrucciones para crear una
    nueva contraseña.
  </p>
  <form (submit)="$event.preventDefault()">
    <p-floatlabel class="mb-3" variant="in">
      <p-iconfield>
        <p-inputicon class="pi pi-envelope" />
        <input
          pInputText
          type="email"
          id="recovery-email"
          class="w-100"
          [formControl]="emailCtrl"
          autocomplete="email"
        />
      </p-iconfield>
      <label for="recovery-email">Email</label>
    </p-floatlabel>
    @if (!!error) {
      <p-message styleClass="mb-3 w-100" severity="error">{{ error }}</p-message>
    }
    <p-button
      type="button"
      [label]="!submitted ? 'Enviar' : 'Enviando...'"
      (onClick)="submit()"
      class="w-100"
      [style]="{ width: '100%' }"
      [disabled]="submitted"
    />
    <div class="d-flex justify-content-center mt-3">
      <p-button severity="secondary" link type="button" (onClick)="navigateTo.emit('LOGIN')">
        Volver a inicio de sesión
      </p-button>
    </div>
  </form>
</p-card>
